<!-- Bouton « Signaler » une publication, un commentaire ou un membre : petit questionnaire (motif + précisions)
     puis envoi à la modération -->
<template>
  <el-button
    :size="size"
    :link="link"
    type="warning"
    class="report-button"
    @click.stop="open"
  >
    Signaler
  </el-button>

  <!-- Hors de la carte parente : un clic dans le questionnaire ne doit pas ouvrir la publication -->
  <el-dialog v-model="visible" :title="title" width="min(500px, 92vw)" class="report-dialog" append-to-body>
    <el-form label-position="top" @submit.prevent>
      <el-form-item label="Pourquoi signalez-vous ce contenu ?">
        <el-radio-group v-model="reason" class="report-reasons">
          <el-radio v-for="item in reasons" :key="item" :value="item">{{ item }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="reason === otherReason ? 'Précisions (obligatoires)' : 'Précisions (facultatives)'">
        <el-input
          v-model="details"
          type="textarea"
          :rows="3"
          maxlength="255"
          show-word-limit
          placeholder="Décrivez le problème"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="visible = false">Annuler</el-button>
      <el-button type="warning" class="send-report-btn" :disabled="!canSend || sending" @click="send">
        Envoyer le signalement
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import api from '@/api';
import { notifySuccess, notifyError } from '@/notify';

// Même liste que REPORT_REASONS (wedoo_backend/src/validators/reportValidators.js)
const OTHER_REASON = 'Autre';
const REPORT_REASONS = [
  'Harcèlement ou intimidation',
  'Propos haineux ou discriminatoires',
  'Violence ou incitation à la violence',
  'Contenu sexuel ou mettant en danger des mineurs',
  'Atteinte à la vie privée ou à l\'image',
  'Atteinte aux droits d\'auteur',
  'Arnaque, spam ou publicité',
  OTHER_REASON,
];

// Par type de cible : route de l'API, champ de l'identifiant et titre du questionnaire
const TARGETS = {
  post: { url: '/report/reportPost', idField: 'reportedPostId', title: 'Signaler cette publication' },
  comment: { url: '/report/reportComment', idField: 'reportedCommentId', title: 'Signaler ce commentaire' },
  user: { url: '/report/reportUser', idField: 'reportedUserId', title: 'Signaler ce membre' },
};

export default {
  name: 'ReportButton',
  props: {
    // 'post' (publication), 'comment' (commentaire) ou 'user' (membre)
    targetType: { type: String, required: true, validator: (value) => Object.keys(TARGETS).includes(value) },
    targetId: { type: [Number, String], required: true },
    size: { type: String, default: 'small' },
    link: { type: Boolean, default: false },
  },

  data() {
    return {
      visible: false,
      // Évite un double signalement sur double clic
      sending: false,
      reason: '',
      details: '',
      reasons: REPORT_REASONS,
      otherReason: OTHER_REASON,
    };
  },

  computed: {
    title() {
      return TARGETS[this.targetType].title;
    },
    canSend() {
      return Boolean(this.reason) && (this.reason !== OTHER_REASON || this.details.trim() !== '');
    },
  },

  methods: {
    open() {
      this.reason = '';
      this.details = '';
      this.visible = true;
    },

    async send() {
      if (!this.canSend || this.sending) return;
      const { url, idField } = TARGETS[this.targetType];
      this.sending = true;
      try {
        await api.post(url, { [idField]: Number(this.targetId), reason: this.reason, message: this.details.trim() || null });
        this.visible = false;
        notifySuccess('Signalement envoyé à la modération');
      } catch (error) {
        notifyError(error, "Le signalement n'a pas pu être envoyé");
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style scoped>
.report-reasons {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
